/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_CostInputs */

const en_landing_studio_cost = /** @type {(inputs: Landing_Studio_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This generation`)
};

const zh_landing_studio_cost = /** @type {(inputs: Landing_Studio_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本次消耗`)
};

/**
* | output |
* | --- |
* | "This generation" |
*
* @param {Landing_Studio_CostInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_cost = /** @type {((inputs?: Landing_Studio_CostInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_CostInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_cost(inputs)
	return zh_landing_studio_cost(inputs)
});
export { landing_studio_cost as "landing.studio.cost" }